function cartOrderPaymentCheckout() {
  var insuranceSelectionWithGolfer = {
    selectIds: [],
    submitButton: $('#submit-payment'),
    totalPriceValue: $('#total-price-value'),
    phoneInput: $('#insurance_subject_order_phoneNumber'),
    submitOnChange: $('.insurance-submit-on-change'),
    upperCase: $('.uppercase'),
    onlyNumbers: $('.only-numbers'),
    removeSpace: $('.remove-space'),
    selectBox: $('#insurance_selection_with_golfer_golfClub'),
    phonePrefixAdded: false,
    request: null,

    init: function () {
      this.form = this.submitButton.closest('form');
      var request = this.request;
      var submitForm = false;

      var app = this;
      this.submitButton.on('click', function (event) {
        event.preventDefault();
        submitForm = true;
        app.submitForm(app.form.serialize(), request, submitForm, event.target);
      });
      this.submitOnChange.on('change', function (event) {
        event.preventDefault();
        submitForm = false;
        app.submitForm(app.form.serialize(), request, submitForm, event.target);
      });
      /*      $('select').each(function (event) {
        $(this).trigger('change');
        event.preventDefault();
        submitForm = false;
        app.submitForm(app.form.serialize(), request, submitForm, event.target);
      });*/

      this.upperCase.keyup(function () {
        $(this).val($(this).val().toUpperCase());
      });
      this.onlyNumbers.keyup(function () {
        $(this).val($(this).val().replace(/\D/g, ''));
      });
      this.removeSpace.keyup(function () {
        $(this).val($(this).val().replace(/\s/g, ''));
      });
      this.selectBox.on('change', function (event) {
        $('.error-select-box').remove();
        $('.select2-selection--single').removeClass('error');
      });
    },
    submitForm: function (serializedForm, request, submitForm, targetElement) {
      var app = this;
      if (request !== null) {
        request.abort();
      }
      request = $.ajax({
        url: this.form.attr('action'),
        method: 'POST',
        data: serializedForm,
        beforeSend: function () {
          console.log(serializedForm);
          app.disableButton(true);
        },
        success: function (response) {
          var responseObject = $.parseJSON(response);
          console.log(responseObject);
          app.showTotalPrice(responseObject);
          app.showCoupon(responseObject);
          $('.pricing-with-golfer-input').removeClass('is-danger');
          $('.select2-selection--single').removeClass('is-danger');
          $('.insurance-submit-on-change').removeClass('is-danger');
          $('.form-error').remove();
          refreshPrice();
          if (responseObject.ok) {
            if (submitForm) {
              $('.preloader').removeClass('is-loaded');
              app.submitFormDefault();
            }
            if (targetElement.id === 'personal_information_smsCode') {
              app.submitFormWithSmsCode();
            }
          } else {
            app.displayErrors(responseObject.errors, submitForm, targetElement);
          }
        },
        error: function (xhr, status, error) {
          var err = eval('(' + xhr.responseText + ')');
          alert(err.Message);
          app.showMessage(xhr.responseText, 'error');
        },
        complete: function () {
          app.enableButton();
        },
      });
    },
    showMessage: function (message, type) {
      console.log(message + ' ' + type);
    },
    displayErrors: function (errors, submitForm, targetElement) {
      var app = this;
      if (submitForm) {
        $.each(errors, function (key, value) {
          var element = $('#insurance_order_' + key);
          if ('insurance_order_' + key === 'insurance_order_phoneNumber') {
            element
              .parent()
              .after(
                '<p class="form-error" id="first-error">' + value + '</p>'
              );
          } else if (app.selectIds.includes('insurance_order_' + key)) {
            element
              .parent()
              .after(
                '<p class="form-error" id="first-error">' + value + '</p>'
              );
            element.next('.select-selected').addClass('is-danger');
          } else if (
            'insurance_order_' + key === 'insurance_order_contractCheckbox' ||
            'insurance_order_' + key === 'insurance_order_gdprCheckbox'
          ) {
            element
              .parent()
              .after(
                '<p class="form-error" id="first-error">' + value + '</p>'
              );
            element.next('.select-selected').addClass('is-danger');
          } else {
            element.after(
              '<p class="form-error" id="first-error">' + value + '</p>'
            );
          }

          element.addClass('is-danger');
          // return false;
        });

        // console.log(this.selectBox.find(':selected').val());
        // if (this.selectBox.find(':selected').val() === '') {
        //   this.selectBox.parent().after(
        //     '<p class="form-error error-select-box" id="first-error">' +
        //       this.selectBox.data('error') +
        //       '</p>'
        //   );
        //   $('.select2-selection--single').addClass('is-danger');
        // }

        $('html, body').animate(
          {
            scrollTop: $('#first-error').offset().top - 180,
          },
          1000
        );
      } else {
        $.each(errors, function (key, value) {
          var element = $('#insurance_order_' + key);
          if ('insurance_order_' + key === targetElement.id) {
            if ('insurance_order_' + key === 'insurance_order_phoneNumber') {
              element
                .parent()
                .after(
                  '<p class="form-error" id="first-error">' + value + '</p>'
                );
            } else if (app.selectIds.includes('insurance_order_' + key)) {
              element
                .parent()
                .after(
                  '<p class="form-error" id="first-error">' + value + '</p>'
                );
              element.next('.select-selected').addClass('is-danger');
            } else {
              element.after(
                '<p class="form-error" id="first-error">' + value + '</p>'
              );
            }

            element.addClass('is-danger');
          }
        });
      }
    },
    showTotalPrice: function (responseObject) {
      if (responseObject.transformedOrder) {
        $('#total-price-value').text(
          responseObject.transformedOrder.totalPriceCZK + ' Kč'
        );
      }
    },
    showCoupon: function (responseObject) {
      var couponBlock = $('.coupon-info-js');
      couponBlock.hide();
      $('#select-payment-section').show();
      $('.total-price').data('coupon-value', 0).data('coupon-type', 0);
      if (
        responseObject.transformedOrder &&
        responseObject.transformedOrder.coupon
      ) {
        var coupon = responseObject.transformedOrder.coupon;
        $.each(coupon.addProducts, function () {
          $('#summary-list').append(
            '<li class="arrange--summary--li coupon-info-js">\n' +
              '                                      <div class="arrange--summary--icon">\n' +
              '                                          <span>+</span>\n' +
              '                                      </div>\n' +
              '                                      <div class="arrange--summary--content">\n' +
              '                                          <div class="arrange--summary--content--price">Kupón</div>\n' +
              '                                          <p class="arrange--summary--content--text">' +
              this.checkoutDescriptionCs +
              '</p>\n' +
              '                                      </div>\n' +
              '                                  </li>'
          );
        });
        if (coupon.discountType === 1 || coupon.discountType === 2) {
          couponBlock.show();
          $('.total-price')
            .text(responseObject.transformedOrder.totalPriceCZK + ' Kč/rok')
            .data('coupon-value', coupon.valueCZK)
            .data('coupon-type', coupon.discountType);
          // $('#coupon-price-before').text('Původně ' + responseObject.transformedOrder.productsPriceCZK + ' Kč');
          $('#coupon-value').text(
            'Sleva ' + responseObject.transformedOrder.discountValueCZK + ' Kč'
          );

          if (
            (responseObject.transformedOrder.csOrder &&
              responseObject.transformedOrder.totalPriceCZK === 0) ||
            (!responseObject.transformedOrder.csOrder &&
              responseObject.transformedOrder.totalPriceEUR === 0)
          ) {
            $('#select-payment-section').hide();
          }
        }
        if (coupon.discountType === 3) {
          couponBlock.show();
          let totalPricejQuery = $('.total-price');
          let freeMonths = coupon.freeMonths;
          totalPricejQuery.text(
            responseObject.transformedOrder.totalPriceCZK +
              ' Kč/rok + ' +
              freeMonths +
              ' měsíců zdarma'
          );
        }
      }
    },
    disableButton: function () {
      this.submitButton.attr('disabled', 'disabled');
    },
    enableButton: function () {
      this.submitButton.attr('disabled', false);
    },
    submitFormDefault: function () {
      if (this.selectBox.find(':selected').val() === '') {
        this.selectBox.after(
          '<span class="form-error error-select-box" id="first-error">' +
            this.selectBox.data('error') +
            '</span>'
        );
        $('.select2-selection--single').addClass('error');

        $('html, body').animate(
          {
            scrollTop: $('#first-error').offset().top - 180,
          },
          1000
        );

        return;
      }
      this.form.submit();
    },
  };

  $(function () {
    insuranceSelectionWithGolfer.init();
  });

  $(function () {
    $('#insurance_selection_with_golfer_dateOfBirth').datetimepicker({
      format: 'DD.MM.YYYY',
      locale: 'cs',
    });

    var inputLocale = $('#input-locale').val();
    $('#insurance_selection_with_golfer_golfClub').select2({
      language: {
        noResults: function () {
          if (inputLocale === 'en') {
            return 'No results found';
          } else {
            return 'Nenalezeny žádné položky.';
          }
        },
      },
    });

    var updateInsuranceInput = $('#update-insurance-input');
    var updateInsuranceInputMinDate = $('#update-insurance-input-min-date');
    var changeInsuranceInput = $('#change-insurance-input');
    var changeInsuranceInputMinDate = $('#change-insurance-input-min-date');
    if (updateInsuranceInput.length !== 0) {
      $('#insurance_selection_with_golfer_timeToProcess').datetimepicker({
        format: 'DD.MM.YYYY',
        locale: 'cs',
        useCurrent: false,
        minDate: moment(updateInsuranceInputMinDate.val(), 'DD.MM.YYYY'),
        defaultDate: moment(updateInsuranceInput.val(), 'DD.MM.YYYY'),
      });
    } else if (changeInsuranceInput.length !== 0) {
      $('#insurance_selection_with_golfer_timeToProcess').datetimepicker({
        format: 'DD.MM.YYYY',
        locale: 'cs',
        useCurrent: false,
        minDate: moment(changeInsuranceInputMinDate.val(), 'DD.MM.YYYY'),
        defaultDate: moment(changeInsuranceInput.val(), 'DD.MM.YYYY'),
      });
    } else {
      $('#insurance_selection_with_golfer_timeToProcess').datetimepicker({
        format: 'DD.MM.YYYY',
        locale: 'cs',
        minDate: moment().add(1, 'day'),
      });
    }
  });

  function refreshPrice() {
    var selectedGolfer = $(
      '[name="insurance_selection_with_golfer[golferGameProduct]"]:checked'
    );
    var selectedClubs = $(
      '[name="insurance_selection_with_golfer[clubsProduct]"]:checked'
    );
    var selectedTrolley = $(
      '[name="insurance_selection_with_golfer[trolleyProduct]"]:checked'
    );
    var selectedYears = $(
      '#insurance_selection_with_golfer_insuranceLength'
    ).val();
    var saleTwoYears = $('#insurance-length-setup').data('sale-two-years');
    var saleThreeYears = $('#insurance-length-setup').data('sale-three-years');
    var saleProlongation = $('#insurance-prolongation-setup').data(
      'sale-prolongation'
    );
    var saleProlongationType = $('#insurance-prolongation-setup').data(
      'sale-prolongation-type'
    );
    var couponBlock = $('.coupon-info-js');

    if (
      selectedGolfer.length &&
      selectedClubs.length &&
      selectedTrolley.length
    ) {
      // $("#pricing-bar").show();

      var golferPriceElm = $('#golfer-game-price');
      var clubsPriceElm = $('#clubs-game-price');
      var troleyPriceElm = $('#troley-price');
      var totalPriceElm = $('.total-price');

      var couponValue = totalPriceElm.data('coupon-value');
      var couponType = totalPriceElm.data('coupon-type');

      var golfer = $('[data-value="' + selectedGolfer.val() + '"]');
      var golferPrices = golfer.data('price');
      var golferPrice = golferPrices['default-czk'];

      if (selectedTrolley.val() !== '') {
        var trolley = $('[data-value="' + selectedTrolley.val() + '"]');
        var trolleyPrices = trolley.data('price');
        var troleyPrice = trolleyPrices['default-czk'];
      } else {
        troleyPrice = 0;
      }

      if (selectedClubs.val() !== '') {
        var clubs = $('[data-value="' + selectedClubs.val() + '"]');
        var clubsPrices = clubs.data('price');
        var clubsPrice = clubsPrices['default-czk'];
      } else {
        clubsPrice = 0;
        golferPrice = golferPrices['not-clubs'];
      }

      // if (clubs.data('type') > 1) {
      //   golferPrices = (golfer.data('price'));
      //   golferPrice = golferPrices['clubs'][clubs.data('type')];
      // }

      var yearsSale = 0;
      var couponSale = 0;
      var prolongationSale = 0;
      var productPrice = golferPrice + clubsPrice + troleyPrice;

      if (selectedYears === '2') {
        productPrice = productPrice * 2;
      } else if (selectedYears === '3') {
        productPrice = productPrice * 3;
      }
      var finalPrice = productPrice;

      couponBlock.hide();

      if (couponType > 0) {
        if (couponType === 1) {
          couponSale = couponValue;
        } else if (couponType === 2) {
          couponSale = productPrice * (couponValue * 0.01);
        }
        finalPrice = productPrice - couponSale;
      }

      var yearText = 'rok';
      if (selectedYears !== '1') {
        if (selectedYears === '2') {
          yearText = '2 roky';
          yearsSale = finalPrice * (saleTwoYears / 100);
        } else if (selectedYears === '3') {
          yearText = '3 roky';
          yearsSale = finalPrice * (saleThreeYears / 100);
        }
        finalPrice = finalPrice - yearsSale;
      }

      if (saleProlongation) {
        if (saleProlongationType == 1) {
          prolongationSale = saleProlongation;
          finalPrice = finalPrice - prolongationSale;
        } else {
          prolongationSale = finalPrice * (saleProlongation / 100);
          finalPrice = finalPrice - prolongationSale;
        }
      }

      if (finalPrice < 0) {
        finalPrice = 0;
        yearsSale = 0;
        couponSale = productPrice;
      }

      if (yearsSale > 0 || couponValue > 0 || saleProlongation > 0) {
        couponBlock.show();
        $('#coupon-price-before').text('Původně ' + productPrice + ' Kč');
        $('#coupon-value').text(
          'Sleva ' + (yearsSale + couponSale + prolongationSale) + ' Kč'
        );
      }

      var inputLocale = $('#input-locale').val();

      if (inputLocale === 'en') {
        golferPriceElm.text('CZK ' + golferPrice + '/year');
        clubsPriceElm.text('CZK ' + clubsPrice + '/year');
        totalPriceElm.text('CZK ' + finalPrice + '/year');
      } else {
        golferPriceElm.text(golferPrice + 'Kč/rok');
        clubsPriceElm.text(clubsPrice + 'Kč/rok');
        totalPriceElm.text(finalPrice + 'Kč/' + yearText);
      }

      var pricingBarTrolley = $('.pricing-bar--item--trolley');
      if (selectedTrolley.val() !== '') {
        if (inputLocale === 'en') {
          troleyPriceElm.text('CZK ' + troleyPrice + '/year');
        } else {
          troleyPriceElm.text(troleyPrice + 'Kč/rok');
        }
        pricingBarTrolley.show();
      } else {
        pricingBarTrolley.hide();
      }
    } else {
      // $("#pricing-bar").hide();
    }
  }

  function setActivePricingValue($element, baseClass, tabId, inputName) {
    $baseElement = $('.pricing--variant--' + baseClass);

    $baseElement.removeClass(
      'pricing--variant--' +
        baseClass +
        '--1 pricing--variant--' +
        baseClass +
        '--2 pricing--variant--' +
        baseClass +
        '--3'
    );
    $baseElement
      .find('.pricing--variant--item')
      .removeClass('pricing--variant--item--active');

    $element.addClass('pricing--variant--item--active');

    $baseElement.addClass('pricing--variant--' + baseClass + '--' + tabId);

    $(
      '[name="insurance_selection_with_golfer[' +
        inputName +
        ']"][value=' +
        $element.data('value') +
        ']'
    ).prop('checked', true);

    $('.pricing-bar--total--price').removeClass('is-zoom');
    setTimeout(function () {
      $('.pricing-bar--total--price').addClass('is-zoom');
      refreshPrice();
    }, 100);

    $('.golfer-game-price, .clubs-game-price, .troley-price').removeClass(
      'is-zoom'
    );
    setTimeout(function () {
      $('.golfer-game-price, .clubs-game-price, .troley-price').addClass(
        'is-zoom'
      );
      refreshPrice();
    }, 100);
  }

  $(document).ready(function () {
    var selectedGolfer = $(
      '[name="insurance_selection_with_golfer[golferGameProduct]"]:checked'
    );
    var selectedClubs = $(
      '[name="insurance_selection_with_golfer[clubsProduct]"]:checked'
    );
    var selectedTrolley = $(
      '[name="insurance_selection_with_golfer[trolleyProduct]"]:checked'
    );

    if (0 === selectedGolfer.length) {
      selectedGolfer = $(
        '[name="insurance_selection_with_golfer[golferGameProduct]"]'
      ).first();
    }

    if (0 === selectedClubs.length) {
      selectedClubs = $(
        '[name="insurance_selection_with_golfer[clubsProduct]"]'
      ).first();
    }

    if (0 === selectedTrolley.length) {
      selectedTrolley = $(
        '[name="insurance_selection_with_golfer[trolleyProduct]"]'
      ).first();
    }

    setTimeout(function () {
      if (selectedTrolley.val() !== '') {
        $('.pricing--optional').slideDown(300);
        $('.pricing--optional, .pricing--optional--cta').addClass('is-open');
      }
    }, 1000);

    console.log(selectedGolfer, selectedClubs, selectedTrolley);

    var taba = $('.golfer-product[data-value="' + selectedGolfer.val() + '"]');
    setActivePricingValue(
      taba,
      'golfer-game',
      taba.attr('data-tab'),
      'golferGameProduct'
    );

    var tabb = $('.clubs-product[data-value="' + selectedClubs.val() + '"]');
    setActivePricingValue(tabb, 'clubs', tabb.attr('data-tab'), 'clubsProduct');

    var tabc = $(
      '.trolley-product[data-value="' + selectedTrolley.val() + '"]'
    );
    setActivePricingValue(
      tabc,
      'trolley',
      tabc.attr('data-tab'),
      'trolleyProduct'
    );

    refreshPrice();

    if (
      selectedClubs.val() === '' &&
      !$('.pricing-clubs-optional').hasClass('tag-as-hidden')
    ) {
      selectedClubs = $(
        '[name="insurance_selection_with_golfer[clubsProduct]"]'
      ).eq(1);
      var tabb = $('.clubs-product[data-value="' + selectedClubs.val() + '"]');
      setActivePricingValue(
        tabb,
        'clubs',
        tabb.attr('data-tab'),
        'clubsProduct'
      );

      // if(getCookie('clubs-option') === 'false') {
      //   var pricingClubsOptional = $('.pricing-clubs-optional');
      //   pricingClubsOptional.slideUp(300).addClass('tag-as-hidden');
      //   selectedClubs = $('[name="insurance_selection_with_golfer[clubsProduct]"]:checked');
      //   tabb = $('.clubs-product[data-value="' + selectedClubs.val() +'"]');
      //   $('[name="insurance_selection_with_golfer[clubsProduct]"][value=""]').prop("checked", true);
      //   refreshPrice();
      //   $('.clubs-toggle').click();
      // }
    }

    $('.pricing--variant--golfer-game .pricing--variant--item').click(
      function () {
        var tab_id = $(this).attr('data-tab');
        setActivePricingValue(
          $(this),
          'golfer-game',
          tab_id,
          'golferGameProduct'
        );
      }
    );

    $('.pricing--variant--clubs .pricing--variant--item').click(function () {
      var tab_id = $(this).attr('data-tab');
      setActivePricingValue($(this), 'clubs', tab_id, 'clubsProduct');
    });

    $('.pricing--variant--trolley .pricing--variant--item').click(function () {
      var tab_id = $(this).attr('data-tab');
      setActivePricingValue($(this), 'trolley', tab_id, 'trolleyProduct');
    });

    $('.arrow-change-selected-new').click(function () {
      var insuranceType = $(this).attr('data-insurance-type');
      var dataTabActive = parseInt(
        $(
          '.pricing--variant--' +
            insuranceType +
            ' .pricing--variant--item.pricing--variant--item--active'
        ).attr('data-tab')
      );
      if ($(this).attr('data-direction') === 'before') {
        if (dataTabActive > 1) {
          dataTabActive = dataTabActive - 1;
          $(
            '.pricing--variant--' +
              insuranceType +
              ' .pricing--variant--item[data-tab="' +
              dataTabActive +
              '"]'
          ).click();
        }
      } else {
        if (dataTabActive < 3) {
          dataTabActive = dataTabActive + 1;
          $(
            '.pricing--variant--' +
              insuranceType +
              ' .pricing--variant--item[data-tab="' +
              dataTabActive +
              '"]'
          ).click();
        }
      }
    });

    $('.trolley-toggle').on('click', function (e) {
      var pricingTrolleyOptional = $('.pricing-trolley-optional');
      var dataTab = $(this).data('tab');
      if (
        pricingTrolleyOptional.hasClass('tag-as-hidden') &&
        dataTab === 'left'
      ) {
        pricingTrolleyOptional.slideDown(300).removeClass('tag-as-hidden');
        selectedTrolley = $(
          '[name="insurance_selection_with_golfer[trolleyProduct]"]:checked'
        );
        if (selectedTrolley.val() === '') {
          selectedTrolley = $(
            '[name="insurance_selection_with_golfer[trolleyProduct]"]'
          ).eq(1);
        }
        tabc = $(
          '.trolley-product[data-value="' + selectedTrolley.val() + '"]'
        );
        setActivePricingValue(
          tabc,
          'trolley',
          tabc.attr('data-tab'),
          'trolleyProduct'
        );
        refreshPrice();
      } else if (
        !pricingTrolleyOptional.hasClass('tag-as-hidden') &&
        dataTab === 'right'
      ) {
        pricingTrolleyOptional.slideUp(300).addClass('tag-as-hidden');
        selectedTrolley = $(
          '[name="insurance_selection_with_golfer[trolleyProduct]"]:checked'
        );
        tabc = $(
          '.trolley-product[data-value="' + selectedTrolley.val() + '"]'
        );
        $(
          '[name="insurance_selection_with_golfer[trolleyProduct]"][value=""]'
        ).prop('checked', true);
        refreshPrice();
      }
    });

    $('.clubs-toggle').on('click', function (e) {
      var pricingClubsOptional = $('.pricing-clubs-optional');
      var dataTab = $(this).data('tab');
      var golferGameSale = $('.golfer-game-sale');
      if (
        pricingClubsOptional.hasClass('tag-as-hidden') &&
        dataTab === 'left'
      ) {
        golferGameSale.slideDown(300);
        pricingClubsOptional.slideDown(300).removeClass('tag-as-hidden');
        selectedClubs = $(
          '[name="insurance_selection_with_golfer[clubsProduct]"]:checked'
        );
        if (selectedClubs.val() === '') {
          selectedClubs = $(
            '[name="insurance_selection_with_golfer[clubsProduct]"]'
          ).eq(1);
        }
        tabb = $('.clubs-product[data-value="' + selectedClubs.val() + '"]');
        setActivePricingValue(
          tabb,
          'clubs',
          tabb.attr('data-tab'),
          'clubsProduct'
        );
        refreshPrice();
      } else if (
        !pricingClubsOptional.hasClass('tag-as-hidden') &&
        dataTab === 'right'
      ) {
        golferGameSale.slideUp(300);
        pricingClubsOptional.slideUp(300).addClass('tag-as-hidden');
        selectedClubs = $(
          '[name="insurance_selection_with_golfer[clubsProduct]"]:checked'
        );
        tabb = $('.clubs-product[data-value="' + selectedClubs.val() + '"]');
        $(
          '[name="insurance_selection_with_golfer[clubsProduct]"][value=""]'
        ).prop('checked', true);
        refreshPrice();
      }
    });

    var selectedYears = $('.select-items');
    selectedYears.on('click', function () {
      refreshPrice();
    });

    $('#stepper-next-button').click(function (e) {
      e.preventDefault();
      $('#insurance_selection_submit').click();
    });
  });
}
